export var CLICK = 'CLICK';
export var MISSED_CLICK = 'MISSED_CLICK';
export var MOVE_MOUSE = 'MOVE_MOUSE';
export var SCROLL = 'SCROLL';
